const SSL = process.env.NODE_ENV === "production" ? "https://" : "https://";
export const HOST = process.env.NODE_ENV === "production" ? `${SSL}ven.cgseconno.in` : `${SSL}ven.cgseconno.in`;
